module.exports = __webpack_public_path__ + "img/background056.fcc8d04e.jpg";